import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

const TIMEZONE_SUFFIX_PATTERN = /(z|[+-]\d{2}:?\d{2})$/i

// All numeric datetime values are millisecond timestamps.
// The backend (StruxHub.Graph) is aligned to ms everywhere:
// import, storage, GraphQL serialization, and telemetry.
const toValidDate = (ms: number): Date | null => {
  const date = new Date(ms)
  return Number.isNaN(date.getTime()) ? null : date
}

export const parseDateValue = (
  value: any,
  projectDateStore?: ProjectDateStore | null,
): Date | null => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : new Date(value)
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    if (value === 0) {
      return null
    }
    return toValidDate(value)
  }

  const rawValue = String(value).trim()
  if (!rawValue) {
    return null
  }

  const numericValue = Number(rawValue)
  if (Number.isFinite(numericValue)) {
    if (numericValue === 0) {
      return null
    }
    return toValidDate(numericValue)
  }

  if (TIMEZONE_SUFFIX_PATTERN.test(rawValue)) {
    return toValidDate(Date.parse(rawValue))
  }

  if (projectDateStore) {
    const projectDate = projectDateStore.fromIsoString(rawValue)
    if (projectDate && !Number.isNaN(projectDate.getTime())) {
      return projectDate
    }
  }

  return toValidDate(Date.parse(rawValue))
}

export const toMidnightTimestamp = (
  date: Date,
  projectDateStore?: ProjectDateStore | null,
): number => {
  if (projectDateStore) {
    const isoDate = projectDateStore.getDashedFormattedDate(date)
    const midnight = projectDateStore.combineISODateTime(isoDate)
    if (midnight && !Number.isNaN(midnight.getTime())) {
      return midnight.getTime()
    }
  }

  const normalized = new Date(date)
  normalized.setHours(0, 0, 0, 0)
  return normalized.getTime()
}
